import { imgMap, getCookie } from '@/utils';

export default {
  name: 'appDownload',
  data() {
    return {
      flag: false,
      resource: '',
    };
  },
  watch: {
    appDownload(v) {
      if (v) { this.flag = true; }
    },
  },
  computed: {
    navList() {
      return [
        {
          url: this.imgs.download_flag_1,
          title: this.$t('appDownLoad.flag')[0].title,
          desc: this.$t('appDownLoad.flag')[0].desc,
        },
        {
          url: this.imgs.download_flag_2,
          title: this.$t('appDownLoad.flag')[1].title,
          desc: this.$t('appDownLoad.flag')[1].desc,
        },
        {
          url: this.imgs.download_flag_3,
          title: this.$t('appDownLoad.flag')[2].title,
          desc: this.$t('appDownLoad.flag')[2].desc,
        },
        {
          url: this.imgs.download_flag_4,
          title: this.$t('appDownLoad.flag')[3].title,
          desc: this.$t('appDownLoad.flag')[3].desc,
        },
      ];
    },
    // stepList() {
    //   const { lan } = this.$store.state.baseData;
    //   // let lang = lan;
    //   let imgList = [];
    //   if (lan !== 'zh_CN') {
    //     // lang = 'en_US';
    //     imgList = [
    //       'https://vdollarex.oss-ap-southeast-1.aliyuncs.com/upload/20210621034349552.png',
    //       'https://vdollarex.oss-ap-southeast-1.aliyuncs.com/upload/20210621034402461.png',
    //       'https://vdollarex.oss-ap-southeast-1.aliyuncs.com/upload/20210621034417528.png',
    //     ];
    //   } else {
    //     imgList = [
    //       'https://vdollarex.oss-ap-southeast-1.aliyuncs.com/upload/20210621034300825.png',
    //       'https://vdollarex.oss-ap-southeast-1.aliyuncs.com/upload/20210621034318694.png',
    //       'https://vdollarex.oss-ap-southeast-1.aliyuncs.com/upload/20210621034334715.png',
    //     ];
    //   }
    //   return [
    //     {
    //       url: imgList[0],
    //       step: this.$t('appDownLoad.setUpTestFlignt.step')[0].step,
    //       title: this.$t('appDownLoad.setUpTestFlignt.step')[0].title,
    //       desc: this.$t('appDownLoad.setUpTestFlignt.step')[0].desc,
    //     },
    //     {
    //       url: imgList[1],
    //       step: this.$t('appDownLoad.setUpTestFlignt.step')[1].step,
    //       title: this.$t('appDownLoad.setUpTestFlignt.step')[1].title,
    //       desc: this.$t('appDownLoad.setUpTestFlignt.step')[1].desc,
    //     },
    //     {
    //       url: imgList[2],
    //       step: this.$t('appDownLoad.setUpTestFlignt.step')[2].step,
    //       title: this.$t('appDownLoad.setUpTestFlignt.step')[2].title,
    //       desc: this.$t('appDownLoad.setUpTestFlignt.step')[2].desc,
    //     },
    //     // {
    //     //   url: this.imgs[`download_ios_04_${lang}`],
    //     //   step: this.$t('appDownLoad.setUp.step')[3].step,
    //     //   title: this.$t('appDownLoad.setUp.step')[3].title,
    //     //   desc: this.$t('appDownLoad.setUp.step')[3].desc,
    //     // },
    //     // {
    //     //   url: this.imgs[`download_ios_05_${lang}`],
    //     //   step: this.$t('appDownLoad.setUp.step')[4].step,
    //     //   title: this.$t('appDownLoad.setUp.step')[4].title,
    //     //   desc: this.$t('appDownLoad.setUp.step')[4].desc,
    //     // },
    //   ];
    // },
    appDownload() {
      return this.$store.state.baseData.app_download;
    },
    mainBg() {
      return `background-image: url("${imgMap.appdownload_bg}#0E1A2E"`;
    },
    imgs() {
      return imgMap;
    },
  },
  methods: {
    linkAppstore() {
      const { lan } = this.$store.state.baseData;
      if (this.resource === 'apple') {
        // lan === 'en_US' ? window.open('https://apps.apple.com/us/app/vdollar-exchange/id1540802717') : window.open('https://apps.apple.com/us/app/vdollar-exchange/id1540802717?l=zh');
        window.open(this.appDownload.ios_download_url);
      } else {
        window.open(this.appDownload.android_download_url);
      }
    },
    linkGoogle() {
      if (this.resource === 'apple') {
        window.scrollTo(0, document.getElementsByClassName('download-step')[0].offsetTop);
        window.open(this.appDownload.ios_download_url);
      } else {
        // window.open('https://play.google.com/store/apps/details?id=com.chainup.exchange.vdollar');
        window.open(this.appDownload.google_play_url);
      }
    },
    download(type) {
      window.open(this.appDownload[`${type}_download_url`]);
    },
    init() {
      this.getchannelId();
      const footer = document.querySelector('#footer-box');
      if (footer) {
        footer.style.marginTop = 0;
      }
      if (this.appDownload) {
        this.flag = true;
      }
    },
    getchannelId() {
      const { lan } = this.$store.state.baseData;
      // 增加 取地址栏参数 转为小写逻辑
      const curDomain = document.domain.split('.').slice(-1).join() || 'co';
      // const a = window.location.search.toLocaleLowerCase();
      let channelid = getCookie('channelid') || 'vd';
      // 取地址栏参数 转为小写
      const search = window.location.search.toLocaleLowerCase().substring(1);
      const a = search.split('&');
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i <= a.length - 1; i++) {
        if (a[i].indexOf('channelid=') > -1) {
          const b = a[i].split('=')[1] || channelid;
          channelid = b;
        }
      }
      // eslint-disable-next-line no-undef
      const qrcode = new QRCode(document.getElementById('qrcode'), {
        width: 158,
        height: 158,
      });
      const qrcode_tf = new QRCode(document.getElementById('qrcode_tf'), {
        width: 130,
        height: 130,
      });
      const qrcode_android = new QRCode(document.getElementById('qrcode_android'), {
        width: 158,
        height: 158,
      });

      // const url = `https://m.vdollar.${curDomain}/${lan}/install?channelid=${channelid}`;
      // const url = 'https://apps.apple.com/us/app/vdollar-exchange/id1540802717';
      // const url_tf = 'https://tf.blockchaintestflight.com/app/1597054569';
      // const androidUrl = 'https://play.google.com/store/apps/details?id=com.chainup.exchange.vdollar';
      // qrcode.makeCode(url);
      // qrcode_tf.makeCode(url_tf);
      // qrcode_android.makeCode(androidUrl);
    },
  },
};
